module.exports = __webpack_public_path__ + "static/media/velour9B.bb117e6d.jpg";